import axios from 'axios';

export default function getPortfolios(customerId, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };
    const url = config.getPortfolioService;
    return dispatch => dispatch({
        type: 'PORTFOLIOS_FETCH',
        payload: axios({ method: 'post', url, headers, data: { customerId } })
    })
}


// WEBPACK FOOTER //
// ./src/actions/VXC/getPortfolios.js